//#region src/date-picker/types/date-range-filter-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.Last30Days = "last_30_days", e.ThisMonth = "this_month", e.LastMonth = "last_month", e;
}({}), t = /* @__PURE__ */ function(e) {
	return e.AllTime = "all_time", e.Last3Months = "last_3_months", e.EvaluationPeriod = "evaluation_period", e;
}({});
//#endregion
export { t as DateRangeCustomFilterEnum, e as DateRangeFilterEnum };
